import { render, staticRenderFns } from "./HandselCoupon.vue?vue&type=template&id=10339dc1&scoped=true&"
import script from "./HandselCoupon.vue?vue&type=script&lang=js&"
export * from "./HandselCoupon.vue?vue&type=script&lang=js&"
import style0 from "./HandselCoupon.vue?vue&type=style&index=0&id=10339dc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10339dc1",
  null
  
)

export default component.exports